var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{class:[{ 'right' : _vm.side , 'show' : _vm.show},_vm.routeName],attrs:{"id":"slide-in"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }